import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/(default)/blog/page.tsx");
